// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yYc8","colBig":"styles_colBig__33Q7x","colSmall":"styles_colSmall__1oVh7"};